module.exports = __webpack_public_path__ + "static/media/weather-cloudy2.39f0db8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/weather-cloudy2.svg
// module id = 3811
// module chunks = 7